import React, {memo} from "react";
import {
  createStyles,
  Grid,
  InputLabel,
  makeStyles,
  Theme,
  Typography
} from "@material-ui/core";
import { Draggable } from 'react-beautiful-dnd';
import ListItem from '@material-ui/core/ListItem';
import {
  DragDropContext,
  Droppable,
  OnDragEndResponder
} from 'react-beautiful-dnd';
import { NumberField } from ".";
import {t} from "../localization";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    draggingListItem: {
      background: 'rgb(235,235,235)'
    },
    staticListItem: {
      borderBottom: "2px dashed lightgray"
    },
    flexGrow: {
      flexGrow: 1
    }
  })
);

interface DraggableItemProps {
  id: string;
  primary: string;
  secondary: number;
  error?: boolean;
  index: number;
  min?: number,
  max?: number,
  step?: number
};

interface DraggableListItemProps {
  item: DraggableItemProps;
  index: number;
  setData: React.Dispatch<any>;
  inputName: string;
  listLength: number;
}

const DraggableListItem = (props: DraggableListItemProps) => {
  const {item, index, setData, inputName, listLength} = props;
  const classes = useStyles();
  const useStaticListItem = (index === listLength-1) ? '' : classes.staticListItem;

  return (
    <Draggable draggableId={item.id} index={index}>
      {(provided, snapshot) => (
        <ListItem
          ref={provided.innerRef}
          {...provided.draggableProps}
          {...provided.dragHandleProps}
          className={snapshot.isDragging ? classes.draggingListItem : useStaticListItem}
        >
          <div className={classes.flexGrow}>
            <Grid container spacing={0}>
              <Grid item xs>
                <Typography>{t("labels.category-name")}</Typography>
              </Grid>
              <Grid item xs>
                <Typography>{inputName}</Typography>
              </Grid>
            </Grid>
            <Grid container spacing={0}>
              <Grid item xs>
                <InputLabel>{item.primary}</InputLabel>
              </Grid>
              <Grid item xs>
                <NumberField
                  data={{
                    value: item.secondary,
                    error: item.error
                  }}
                  setData={setData}
                  min={item.min}
                  max={item.max}
                  step={item.step}
                  index={item.index}
                />
              </Grid>
            </Grid>
          </div>
        </ListItem>
      )}
    </Draggable>
  );
};

interface DraggableListProps {
  items: DraggableItemProps[];
  onDragEnd: OnDragEndResponder;
  setData: any;
  inputName: string;
};

export const DraggableList = memo((props: DraggableListProps) => {
  const {items, onDragEnd, setData, inputName} = props;

  return (
    <DragDropContext onDragEnd={onDragEnd}>
      <Droppable droppableId="droppable-list">
        {provided => (
          <div ref={provided.innerRef}  {...provided.droppableProps}>
            {items.map((item, index) => (
              <DraggableListItem
                item={item}
                index={index}
                setData={setData}
                inputName={inputName}
                key={item.id}
                listLength={items.length}
              />
            ))}
            {provided.placeholder}
          </div>
        )}
      </Droppable>
    </DragDropContext>
  );
});
